import React from "react";
import {
  IconButton,
  Snackbar,
  SnackbarContent,
  SxProps,
  Theme,
} from "@mui/material";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import theme, { erreur } from "../../theme";

interface Props {
  onClose(): void;
  open: boolean;
  variant: "success" | "error";
  message: string;
}

const styles: SxProps<Theme> = [
  {
    "& .icon": {
      fontSize: 20,
      marginRight: "12px",
    },
    "& .successIcon": {
      color: theme.palette.primary.main,
    },
    "& .errorIcon": {
      color: erreur,
    },
    "& .message": {
      display: "flex",
      alignItems: "center",
    },
  },
];

const Snack: React.FC<Props> = ({ onClose, open, variant, message }) => {
  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={styles}
      open={open}
      onClose={onClose}
    >
      <SnackbarContent
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" className="message">
            {variant === "success" && (
              <CheckCircle className="icon successIcon" />
            )}
            {variant === "error" && <ErrorIcon className="icon errorIcon" />}
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    </Snackbar>
  );
};

export default Snack;
